import { mainApi } from '../api';

export const { useOpenDialogMutation } = mainApi.injectEndpoints({
  endpoints: build => ({
    openDialog: build.mutation<{ open: boolean }, { open: boolean }>({
      queryFn: ({ open }) => {
        return { data: { open } };
      },
    }),
  }),
});
